import { render, staticRenderFns } from "./ExamNumber.vue?vue&type=template&id=7531351b"
import script from "./ExamNumber.vue?vue&type=script&lang=js"
export * from "./ExamNumber.vue?vue&type=script&lang=js"
import style0 from "./ExamNumber.vue?vue&type=style&index=0&id=7531351b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports